<template>
	<dashboard-dropdown-section
		title="Booking History"
		type="locum-booking-history"
		:items-shown="5"
		:items="bookings"
		event-name="load-locum-booking-history"
		@load-locum-booking-history="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'LocumPastBookings',

	components: { DashboardDropdownSection },

	data: () => ({
		bookings: [],
	}),

	methods: {
		...mapActions('bookings', ['LoadProfessionalBookings']),

		async loadMore() {
			const startDate = moment().subtract('months', 3).endOf('month').format('YYYY-MM-DD');
			const endDate = moment().format('YYYY-MM-DD');

			const bookings = await this.LoadProfessionalBookings({ startDate, endDate });
			this.bookings = bookings.map(booking => ({ ...booking, event_start_date: booking.start_date }));
		},
	},
};
</script>
